import ReduxGlobal from "./actionreducers/globalView";

/**
 * Http response state error handler
 */
const httpResponseErrorHandler = (store) => (dispatch) => (action) => {
    let result = null;

    if (action.error) {
        if (action.error.status) {
            switch (action.error.status) {
                /*
                case 400:
                    console.log('登入失敗');
                    dispatch(ReduxGlobal.ActionCreator.openErrorDialog({
                        title: action.error.title,
                        message: action.error.message
                    }));
                    result = action.error;
                    break;
                case 401:
                    console.log('jwt_token 過期 , 需要重新登入');
                    dispatch(ReduxGlobal.ActionCreator.openErrorDialog({
                        title: action.error.title,
                        message: action.error.message
                    }));
                    result = action.error;
                    break;
                */
                case 404:
                case 405:
                case 409:
                case 422:
                    dispatch(ReduxGlobal.ActionCreator.openErrorDialog({
                        title: action.error.title || '操作錯誤',
                        message: action.error.message?  action.error.message : '無法執行 , 您的動作'
                    }));
                    result = action.error;
                    break;
                case 500:
                    console.log('500錯誤碼!!!');
                    dispatch(ReduxGlobal.ActionCreator.openErrorDialog({
                        title: '系統錯誤',
                        message: '無法執行 , 您的動作'
                    }));
                    result = action.error;
                    break;
                default:
                    result = action.error;
                    break;
            }
        } else if (action.error.message === 'Network request failed') {
            // emitter.emit(GlobalAppEvent.NETWORK_REQUEST_FAILED, {message: AppLabels.Common.errorNetwork});
            console.log('網路連線異常');
            dispatch(ReduxGlobal.ActionCreator.openErrorDialog({title: '無法連線到伺服器', message: '網路連線異常'}));
            // result = Promise.reject(dispatch(action));
            result = action.error;
        }
    } else {
        result = dispatch(action);
    }

    return result;
};


export default httpResponseErrorHandler;



// WEBPACK FOOTER //
// ./src/store/httpResponseErrorHandler.js